import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DnDetailSummary } from '../models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class DnDetailSummaryResource {
  private http = inject(HttpClient);

  get = (dnId: string, cucmServerId: string): Observable<DnDetailSummary> => {
    return this.http.get<DnDetailSummary>(
      `/services/cisco/views/cucm-servers/${cucmServerId}/dn-detail-summaries/${encodeURIComponent(dnId)}`,
    );
  };
}
